import { OverviewPeriod } from '@trace/types';
import { DateTime, Duration, DurationObjectUnits } from 'luxon';
import { OVERVIEW_DATE_FORMAT } from '../../constants/Overview';

const labelTargetFormats: Record<OverviewPeriod, string> = {
  daily: 'ccccc',
  weekly: 'MMM',
  monthly: 'MMM',
};

const tickDateTransformers: Record<
  OverviewPeriod,
  (tickDate: DateTime, index: number, allTickDates: DateTime[]) => [string, number]
> = {
  daily: (tickDate) => [tickDate.toFormat(labelTargetFormats.daily), tickDate.toMillis()],
  weekly: (tickDate) => {
    const tickDateMs = tickDate.toMillis();
    const isPreviousDateSameMonth = tickDate.minus({ days: 7 }).hasSame(tickDate, 'month');
    const tickDateLabel = isPreviousDateSameMonth
      ? ''
      : tickDate.toFormat(labelTargetFormats.weekly);

    return [tickDateLabel, tickDateMs];
  },
  monthly: (tickDate) => [tickDate.toFormat(labelTargetFormats.monthly), tickDate.toMillis()],
};

interface Props {
  duration: string;
  period: OverviewPeriod;
  start: string;
  step: keyof DurationObjectUnits;
}

interface Labels {
  range: string;
  ticks: [string, number][];
}

const getOverviewLabels = ({ duration, period, start, step }: Props): Labels => {
  const dur = Duration.fromISO(duration);
  const tickDates = Array.from({ length: dur.get(step) }).map((_, index) =>
    DateTime.fromFormat(start, OVERVIEW_DATE_FORMAT).plus({ [step]: index }),
  );

  const dateRange = `${DateTime.fromFormat(start, OVERVIEW_DATE_FORMAT).toFormat(
    'dd MMMM',
  )} - ${DateTime.fromFormat(start, OVERVIEW_DATE_FORMAT).plus(dur).toFormat('dd MMMM')}`;

  return {
    range: dateRange,
    ticks: tickDates.map(tickDateTransformers[period]),
  };
};

export default getOverviewLabels;
